import store from '../../../store'
import radu_editor from './radu_editor.vue';

window.U_CAMERAS =  new Vue({
    store,
    name : "radu_editor",
    el: '#radu_editor',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },
    components : {
        radu_editor
    }
});
